/**
 * Mock Inventory API service for development
 * Simulates API responses while backend is being developed
 */
class MockInventoryApiService {
  constructor() {
    // Mock product database
    this.mockProducts = [
      {
        codigo: 'ABC123',
        descricao: 'Produto de Teste 1 - Material de Construção',
        estoque: 50,
        minimo: 10,
        unidade: 'M'
      },
      {
        codigo: 'DEF456',
        descricao: 'Produto de Teste 2 - Ferramentas',
        estoque: 5,
        minimo: 15,
        unidade: 'UN'
      },
      {
        codigo: 'GHI789',
        descricao: 'Produto de Teste 3 - Equipamentos',
        estoque: 100,
        minimo: 20,
        unidade: 'KG'
      },
      {
        codigo: 'JKL012',
        descricao: 'Produto de Teste 4 - Materiais Elétricos',
        estoque: 8,
        minimo: 25,
        unidade: 'M'
      },
      {
        codigo: 'MNO345',
        descricao: 'Produto de Teste 5 - Hidráulica',
        estoque: 200,
        minimo: 30,
        unidade: 'M'
      },
      {
        codigo: 'PQR678',
        descricao: 'Produto de Teste 6 - Segurança',
        estoque: 2,
        minimo: 5,
        unidade: 'UN'
      }
    ];
  }

  /**
   * Simulate API delay
   */
  async simulateApiDelay(ms = 500) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Search products by code or description
   */
  async searchProducts(searchTerm) {
    await this.simulateApiDelay();
    
    const filteredProducts = this.mockProducts.filter(product => 
      product.codigo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.descricao.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return {
      products: filteredProducts,
      total: filteredProducts.length,
      searchTerm: searchTerm
    };
  }

  /**
   * Get product suggestions for autocomplete
   */
  async getProductSuggestions(term) {
    await this.simulateApiDelay(200);
    
    const suggestions = this.mockProducts
      .filter(product => 
        product.codigo.toLowerCase().includes(term.toLowerCase()) ||
        product.descricao.toLowerCase().includes(term.toLowerCase())
      )
      .slice(0, 5) // Limit to 5 suggestions
      .map(product => ({
        codigo: product.codigo,
        descricao: product.descricao
      }));

    return suggestions;
  }

  /**
   * Get product details by code
   */
  async getProductDetails(productCode) {
    await this.simulateApiDelay();
    
    const product = this.mockProducts.find(p => p.codigo === productCode);
    
    if (!product) {
      throw new Error('Produto não encontrado');
    }

    return {
      ...product,
      // Additional details that might be available in real API
      categoria: 'Categoria Teste',
      fornecedor: 'Fornecedor Teste',
      preco: 29.99,
      ultimaAtualizacao: new Date().toISOString()
    };
  }
}

const mockInventoryApiService = new MockInventoryApiService();
export default mockInventoryApiService;
